import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Popover, Skeleton, Typography, Space } from "antd";
import { NavLink } from "react-router-dom";
import { selectAdminGroupById } from "../../actions/api";
import { types, errorAction } from "@authzsvc/api-lib";
import { showErrorNotification } from "../../util";
import { TeamOutlined } from "@ant-design/icons";

const AdminGroup = ({ adminId }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [group, setGroup] = useState(undefined);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      const groupResponse = await dispatch(selectAdminGroupById(adminId));
      if (groupResponse && groupResponse.payload) {
        setGroup(groupResponse.payload.data);
      } else if (
        groupResponse.type === errorAction(types.GET_ADMIN_GROUP_BY_ID)
      ) {
        showErrorNotification(
          groupResponse.payload.title,
          groupResponse.payload.data.message
        );
      }
      setIsLoading(false);
    };
    loadData();
  }, [dispatch, adminId]);

  const popoverTitle = (
    <Typography.Title level={5} style={{ margin: 0 }}>
      <TeamOutlined style={{ marginRight: 8, color: "#bfbfbf" }} />
      {group?.groupIdentifier}
    </Typography.Title>
  );

  const popoverContent = (
    <Space direction="vertical" size={0}>
      {group?.displayName && (
        <Space>
          <Typography.Text type="secondary">Name:</Typography.Text>
          <Typography.Text>{group.displayName}</Typography.Text>
        </Space>
      )}
      {group?.description && (
        <Space>
          <Typography.Text type="secondary">Description:</Typography.Text>
          <Typography.Text>{group.description}</Typography.Text>
        </Space>
      )}
      {group?.blocked !== undefined && (
        <Space>
          <Typography.Text type="secondary">Blocked:</Typography.Text>
          <Typography.Text>{group.blocked ? "true" : "false"}</Typography.Text>
        </Space>
      )}
    </Space>
  );

  return isLoading ? (
    <Skeleton active paragraph={{ rows: 1 }} />
  ) : (
    group && (
      <Popover title={popoverTitle} content={popoverContent}>
        <NavLink to={`/group/${group.id}/details`}>
          <span style={{ cursor: "pointer" }}>{group.displayName}</span>
        </NavLink>
      </Popover>
    )
  );
};

AdminGroup.propTypes = {
  adminId: PropTypes.string.isRequired,
};

export default AdminGroup;
